export const InfoIcon = () => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<circle cx="12" cy="12" r="8.25" fill="white" stroke="#646174" strokeWidth="1.5" />
		<path d="M12 11.1475L12 15.8516" stroke="#646174" strokeWidth="1.5" strokeLinecap="square" />
		<path d="M12 8.14746V8.34746" stroke="#646174" strokeWidth="1.5" strokeLinecap="square" />
	</svg>
);
